export default class MassiaDefaultFiltersModalController {
    static $inject = ['$uibModalInstance', 'storageKey', 'SharedDataService', 'MouvementStockService'];

    constructor($uibModalInstance, storageKey, SharedDataService, MouvementStockService) {
        this.$uibModalInstance = $uibModalInstance;
        this.storageKey = storageKey;
        this.SharedDataService = SharedDataService;
        this.MouvementStockService = MouvementStockService;
    }

    $onInit() {
        const saved = localStorage.getItem(this.storageKey);
        if (saved) {
            try {
                const data = JSON.parse(saved);
                this.idSociete = data.idSociete || 0;
                this.idSite = data.idSite || 0;
            } catch (e) {
                this.idSociete = 0;
                this.idSite = 0;
            }
        } else {
            this.idSociete = 0;
            this.idSite = 0;
        }

        this.regroupementsSite = null;
        this.idRegroupementSite = 0;

        this.configSelectSociete = {
            datatype: 'societe',
            params: [],
            readonly: false,
            autoSelectOnlyOne: true,
            callbackOnChange: this.societeChanged,
            callbackOnSelect: this.societeChanged,
            controller: this
        };

        this.configSelectSite = {
            datatype: 'site',
            params: [{ societe: { datalink: 'default_societe' } }],
            autoSelectOnlyOne: true,
            callbackOnChange: this.siteChanged,
            callbackOnSelect: this.siteChanged,
            controller: this
        };
    }

    async societeChanged(idSociete) {
        this.controller.idSite = 0;
        this.controller.idRegroupementSite = 0;
        if (idSociete && idSociete > 0) {
            this.controller.regroupementsSite = await this.controller.MouvementStockService.getRegroupementSites(idSociete);
        } else {
            this.controller.regroupementsSite = [];
        }
    }

    async siteChanged(idSite) {
        if (idSite && idSite > 0) {
            if (this.controller.regroupementsSite === null) {
                this.controller.regroupementsSite = await this.controller.MouvementStockService.getRegroupementSites(this.controller.idSociete);
            }
            const regroupement = this.controller.regroupementsSite.find((r) => {
                return r.sites.find((s) => {
                    return s.id == idSite;
                });
            });
            this.controller.idRegroupementSite = regroupement ? regroupement.id : 0;
        } else {
            this.controller.idRegroupementSite = 0;
        }
    }

    valider() {
        const societeData = this.SharedDataService.getData('default_societe');
        const siteData = this.SharedDataService.getData('default_site');

        const data = {
            idSociete: this.idSociete || 0,
            societeLibelle: societeData ? societeData.libelle : '',
            idSite: this.idSite || 0,
            siteLibelle: siteData ? siteData.libelle : '',
            idRegroupementSite: this.idRegroupementSite || 0
        };

        localStorage.setItem(this.storageKey, JSON.stringify(data));
        this.$uibModalInstance.close(data);
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }
}
